import { render, staticRenderFns } from "./interactionHome.vue?vue&type=template&id=8196db32&"
import script from "./interactionHome.vue?vue&type=script&lang=js&"
export * from "./interactionHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports